var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagFinishDuotoneFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6V12C6 12.5523 6.44772 13 7 13H10.5858C10.851 13 11.1054 13.1054 11.2929 13.2929L12.7071 14.7071C12.8946 14.8946 13.149 15 13.4142 15H19.5C19.706 15 19.8236 14.7648 19.7 14.6L17 11L19.7 7.4C19.8236 7.23519 19.706 7 19.5 7H13.4142C13.149 7 12.8946 6.89464 12.7071 6.70711L11.2929 5.29289C11.1054 5.10536 10.851 5 10.5858 5H7C6.44772 5 6 5.44772 6 6Z",
    fill: "#004EA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 4.5V19.5",
    stroke: "#004EA0",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFinishDuotoneFill);
export default __webpack_public_path__ + "static/media/flag_finish_duotone_fill.c7d05312ee2191ff0f32957fd01585c8.svg";
export { ForwardRef as ReactComponent };